import { lazy } from "react";
import { TranslationText } from "components";
import { NavTabRoutes } from "layouts/NavTabLayout/NavTab/NavTabRoutes";
import { NavTabPath } from "layouts/NavTabLayout/NavTab/types";
import { PortfolioNavigationHeaderLayout } from "layouts/PortfolioNavigationHeaderLayout/PortfolioNavigationHeaderLayout";
import { Navigate, useRoutes } from "react-router-dom";

const Overview = lazy(() =>
  import("./overview").then((module) => ({ default: module.OverviewPage }))
);

const Analytics = lazy(() =>
  import("./analytics").then((module) => ({ default: module.AnalyticsView }))
);

const Holdings = lazy(() =>
  import("./holdings").then((module) => ({ default: module.HoldingsView }))
);
const Holding = lazy(() =>
  import("./holdings/[holdingId]").then((module) => ({
    default: module.HoldingPage,
  }))
);
const Transactions = lazy(() =>
  import("./transactions").then((module) => ({
    default: module.TransactionsPage,
  }))
);
const TransactionDetails = lazy(() =>
  import("./transactions/[transactionId]").then((module) => ({
    default: module.TransactionDetailsPage,
  }))
);
const Documents = lazy(() =>
  import("./documents").then((module) => ({ default: module.DocumentsPage }))
);
const Contact = lazy(() =>
  import("./contact").then((module) => ({ default: module.ContactPage }))
);
const Trading = lazy(() =>
  import("./trading").then((module) => ({ default: module.TradingPage }))
);
const InfoPage = lazy(() =>
  import("./info").then((module) => ({ default: module.InfoPage }))
);

export const portfolioTabRoutes: NavTabPath[] = [
  {
    path: "overview",
    tabLabel: <TranslationText translationKey="navTab.tabs.overview" />,
    tabComponent: <Overview />,
    element: null,
  },
  {
    path: "analytics",
    tabLabel: <TranslationText translationKey="navTab.tabs.analytics" />,
    tabComponent: <Analytics />,
    element: null,
  },
  {
    path: "holdings",
    tabLabel: <TranslationText translationKey="navTab.tabs.holdings" />,
    tabComponent: <Holdings />,
    element: null,
  },
  {
    path: "transactions",
    tabLabel: <TranslationText translationKey="navTab.tabs.transactions" />,
    tabComponent: <Transactions />,
    element: null,
  },
  {
    path: "documents",
    tabLabel: <TranslationText translationKey="navTab.tabs.documents" />,
    tabComponent: <Documents />,
    element: null,
  },
  {
    path: "trading",
    tabLabel: <TranslationText translationKey="navTab.tabs.trading" />,
    tabComponent: <Trading />,
    element: null,
  },
  {
    path: "holdings/:holdingId",
    element: <Holding />,
    tabLabel: null,
    tabComponent: <Holdings />,
    isHidden: true,
  },
  {
    path: "transactions/:transactionId",
    element: <TransactionDetails />,
    tabLabel: null,
    tabComponent: <Transactions />,
    isHidden: true,
  },
];

export const portfolioRoutes = [
  {
    path: "",
    element: <Navigate to="overview" replace />,
  },
  {
    path: "",
    element: <PortfolioNavigationHeaderLayout />,
    children: [
      {
        path: "*",
        element: <NavTabRoutes routes={portfolioTabRoutes} />,
      },
    ],
  },
  {
    path: "contact",
    element: <Contact />,
    tabLabel: null,
    tabComponent: null,
    isHidden: true,
  },
  {
    path: "info",
    element: <InfoPage />,
    tabLabel: null,
    tabComponent: null,
    isHidden: true,
  },
];

export const PortfolioRoutes = () => {
  return useRoutes(portfolioRoutes);
};
